export default {//该方法主要用于维护增减页签功能
    namespaced:true,//命令空间必须有，否则该类会挂在根下。
    state: {
        views:[
            {
                text:"主页",
                code:"mainPage", //该属性为关键属性，全局唯一，主要用于查到currentIndex、组装路由、查找content。
                selected: false,
                collapsible:true,
                closable: false,
                expander: true,
                ref:'tabs',
                currentIndex:0,
                component: () => import('@/views/Home.vue')
            }
        ]
    },
    getters:{
        getTabsView(state){
            return state.views;
        }
        // ,getViweFromTabsView(state, _view){
        //     for(let i=0; i<state.views.length; i++){
        //         const view = state.views[i];
        //         console.log(view.code + ": " + _view.code +": " + (view.code == _view.code));
        //         if(view.code==_view.code){
        //             return view;
        //         }
        //     }
        //     return null;
        // }
    },
    mutations: {
        ADD_TAB_VIEW(state, data){
            let existItem = false;
            //轮循views,如果是新的页签，则添加，否则不添加
            for(let sign =0; sign<state.views.length; sign++){
                let item = state.views[sign];
                if(item.code == data.code){
                    existItem = true;
                    break ;
                }
            }
            if(!existItem){
                //如果是新页签，则新建
                data.ref="tabs";
                state.views.push(data);
            }
        },
        FILTER_VIEW(state, data){
            //console.log(data);
            state.views = state.views.filter((p)=>{
                const bb = p.code !== data.panelCode;
                //console.log(p.code + ":" + data.panelCode + " = "+ bb);
                return bb;
            });
            for(let i=0; i<state.views.length; i++){
                state.views[i].currentIndex=i;
                state.views[i].index=i;
            }
        },
        INIT_VIEWS(state){
            state.views = state.views.filter((p)=>{
                return p.code == "mainPage";
            });
        }
    },
    actions: {
        addTabView({commit},data){
            commit('ADD_TAB_VIEW',data);
        },
        filterNoView({commit},data){
            commit('FILTER_VIEW',data);
        },
        init({commit}){
            commit('INIT_VIEWS');
        }
    }
}